var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 64,
    viewBox: "0 0 67 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_636_168)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.578 44.8L44.088 41.6L49.6006 38.4L55.1106 35.2V48L49.6006 51.2L44.088 54.4L38.578 57.6L33.068 60.8L27.558 64H27.5553L22.0453 60.8L16.5353 57.6L11.0227 54.4L5.51265 51.2H5.51L0 48V16L5.51 12.8H5.51265L11.0227 9.6L16.5327 6.4H16.5353L22.0453 3.2L27.5553 0H27.558L33.068 3.2L38.578 6.4L33.068 9.6L27.558 12.8L22.0453 16L16.5353 19.2L11.0227 22.4V35.2L16.5353 32L22.0453 28.8L27.558 25.6L33.068 22.4L38.578 19.2L44.088 22.4V28.8L38.578 32L33.068 35.2L27.558 38.4L22.0453 41.6L16.5353 44.8L22.0453 48L27.558 51.2L33.068 48L38.578 44.8ZM60.2309 6.17333L65.7436 9.37333L66.1334 9.6V28.8L63.5057 30.328L55.1107 35.2V16L54.2834 15.52L49.6007 12.8L44.5256 9.85333L44.0881 9.6L43.2608 9.12L38.5781 6.4L44.5388 2.93867L49.6007 0L54.721 2.97333L55.1107 3.2L60.2309 6.17333Z",
    fill: "url(#paint0_linear_636_168)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_636_168",
    x1: 0.0611101,
    y1: 47.7333,
    x2: 66.2699,
    y2: 10.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D9764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29913"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_636_168"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.5093,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCircle);
export default __webpack_public_path__ + "static/media/logo-circle.ea570a23699778f72a3451920c8ceaf7.svg";
export { ForwardRef as ReactComponent };